; (function (jQuery) {

	"use strict";

	function Main() {
		var global = {
			navExpanded: false
		};

		var fn = {
			init: function ()
			{
				jQuery('.no-js').removeClass('no-js');

				jQuery('.faqs__question').on('click', fn.handleFAQExpansion);

				jQuery('.match-height').matchHeight();
				jQuery('.match-height-sub-1').matchHeight();
				jQuery('.match-height-sub-2').matchHeight();
				jQuery('.match-height-sub-3').matchHeight();
				jQuery('.match-height-sub-4').matchHeight();
				jQuery('.match-height').matchHeight(); // Repeated

				// Iframe responsive layouts
				jQuery('iframe').each(fn.wrapIframes);
				jQuery('.calculate-aspect-ratio').each(fn.calculateAspectRatio);

				jQuery('.gallery-slider__container').each(fn.gallerySlider); // Gallery Slider

				// Shop Quantity Button
				jQuery('.quantity-picker input').on('change paste keyup cut select', fn.updateProductAddQuantity);

				// SHop Product Variation picker
				jQuery('.variation-picker select').on('change', fn.updateProductVariation);
			},


			handleFAQExpansion: function()
			{
				var FAQItem = jQuery(this).closest('.faqs__item');
				var FAQAnswer = FAQItem.find('.faqs__answer');
				//var navBarMenuIcon = jQuery('.nav-bar__menu-icon');
				if (FAQItem.hasClass('faqs__item--open'))
				{
					FAQItem.removeClass('faqs__item--open');
					FAQAnswer.hide();
				}
				else
				{
					FAQItem.addClass('faqs__item--open');
					FAQAnswer.show();
				}
			},


			// Responsive Videos & Google Maps
			// 1. Wrap any iframes with aspect ratio calculation div (if not already wrapped in templates)
			wrapIframes: function(i, iframe)
			{
				if (!jQuery(iframe).parent('.calculate-aspect-ratio').length)
				{
					//console.log('plop');
					jQuery(iframe).wrap('<div class="calculate-aspect-ratio"></div>');
				}
			},
			// 2. Calculate Aspect Ratio of iFramed content
			// Uses padding-bottom % to allow responsive iFrames
			calculateAspectRatio: function(i, container)
			{
				// Responsive Iframes
				var iframe = jQuery(container).find('iframe');
				if (iframe.length) {
					var height = iframe.attr('height');
					var width = iframe.attr('width');
					if (!isNaN(height) && !isNaN(width) && (+height + +width) > 0) {
						var ratio = height / width * 100;
						jQuery(container).css('padding-bottom', ratio + '%');
					}
				}
				// EU Cookie fix - to prevent zero padding-bottom
				var euCookie = jQuery(container).find('.eucookie');
				if (euCookie.length) {
					jQuery(container).css('padding-bottom', '180px');
				}
			},

			// Slick Slider - Uses jQuery each to bind prev / next with each slider
			//
			gallerySlider: function(i, gallery)
			{
				var slider = jQuery(gallery).find('.gallery-slider');
				var next = jQuery(gallery).find('.gallery-slider__arrow--next');
				var prev = jQuery(gallery).find('.gallery-slider__arrow--prev');
				slider.slick({
					lazyLoad: 'anticipated',
					infinite: true,
					rows: 0,
					prevArrow: prev,
					nextArrow: next,
					dots: true
				});

				slider.on('lazyLoaded', function (e, slick, image, imageSource) {

					// Make lazy loaded image a bg image
					var figure = jQuery(image).parent('figure');
					if (!figure.hasClass('bg-image-loaded')) {
						var img_url = figure.data('lazy-bg-image');
						figure.css('background-image','url("' + img_url + '")').addClass('bg-image-loaded');
					}

					// Repeat for relevant first clone slide
					if (figure.closest('.slide').data('slick-index') == 0) {
						var slide_count = slick.slideCount;
						var clone_slide = slider.find('.slide[data-slick-index=' + slide_count + ']');
						var figure = clone_slide.find('figure');
						var img_url = figure.data('lazy-bg-image');
						figure.css('background-image','url("' + img_url + '")').addClass('bg-image-loaded');
					};
				});
			},

			updateProductAddQuantity: function()
			{
				var quantity_value = jQuery(this).val();
				var quantity_area = jQuery(this).closest('.product__buy');
				var add_to_cart_button = quantity_area.find('.product__button a');
				var add_to_cart_url = add_to_cart_button.attr('href');
				// Create new add-to-cart URL
				add_to_cart_url = add_to_cart_url.split('&')[0];
				add_to_cart_url += "&quantity=" + quantity_value;
				// Replace add-to-cart URL
				add_to_cart_button.attr('href', add_to_cart_url);
			},

			updateProductVariation: function()
			{
				var product = jQuery(this).closest('.product');
				// Get variation values
				var vari_selected = jQuery(this).find(':selected');
				const vari =
				{
					id: vari_selected.data('vari-id'),
					name: vari_selected.data('vari-name'),
					price: vari_selected.data('vari-price'),
					sku: vari_selected.data('vari-sku'),
					img_src: vari_selected.data('vari-img-src'),
				}
				// Reset quantity value and add to cart button
				var quantity_area = product.find('.product__buy');
				quantity_area.find('.quantity-picker input').val(1);
				var add_to_cart_button = quantity_area.find('.product__button a');
				var add_to_cart_url = add_to_cart_button.attr('href');
				add_to_cart_url = add_to_cart_url.split('?')[0];
				add_to_cart_url += "?add-to-cart=" + vari.id + "&quantity=1";
				// Replace add-to-cart URL
				add_to_cart_button.attr('href', add_to_cart_url);
				// Replace product teaser box fields
				product.find('.variation_name').text(vari.name);
				product.find('.variation_sku').text(vari.sku);
				product.find('.variation_price').text(vari.price);
				product.find('.product__image img').attr('src', vari.img_src);
				console.log(vari);
			},

		}

		jQuery(fn.init);
	}

	new Main();
})(jQuery);